import Explore from '.';
import { IRoute } from '../../utils/navigation/routes';

export const exploreRoutes: IRoute[] = [{ path: '/explore', element: <Explore /> }];
